import * as versionApi from '@authoringPlatform/../api/versions';
import * as authorApi from '@authoringPlatform/../api/authors';
import * as questionGroupApi from '@authoringPlatform/../api/questionGroups';
import * as questionApi from '@authoringPlatform/../api/questions';
import * as folderApi from '@authoringPlatform/../api/folders';

import keyBy from 'lodash/keyBy';
import Vue from 'vue';

// global import not accessible so gotta import here
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

const getDefaultState = () => ({
  recentProjects: [],
  authorProjects: [],
  duplicatedVersionKey: 0,
  featuredProjects: [],
  versions: {},
  isLoading: false,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    getAuthorProjects: async ({ commit },) => {
      const authorProjects = await versionApi.getActorVersions();
      commit('SET_AUTHOR_PROJECTS', authorProjects);
    },

    getAllRecentProjects: async ({ commit }, { authorKey }) => {
      commit('IS_LOADING', true);
      const versions = await versionApi.getMostRecentProj(authorKey);
      const versionsWithLocalLastEdit = versions.map((obj) => {
        const zoneName = dayjs.tz.guess();
        obj.lastEdit = dayjs(obj.lastEdit).tz(zoneName).format('MM/DD/YY hh:mmA z');
        return obj;
      });

      commit('SET_RECENT_PROJECTS', versionsWithLocalLastEdit);
      commit('IS_LOADING', false);
    },

    getAllFeaturedProjects: async ({ commit }) => {
      const res = await versionApi.getFeaturedProjects();
      commit('SET_FEATURED_PROJECTS', res);
    },
    getAllVersions: async ({ commit }) => {
      // TODO: userkey param?
      commit('IS_LOADING', true);
      const versionList = await versionApi.getList();
      commit('INSERT_ALL_VERSIONS', versionList);
      commit('IS_LOADING', false);
    },

    createVersion: async ({ commit }, { versionName, isActive }) => {
      /* TODO: the following ajax calls should be merged into one single call */
      const newVersion = await versionApi.createVersion({ payload: { versionName, isActive } });

      const questionGroup = await questionGroupApi.addQuestionGroup({
        payload: {
          name: 'E-1',
          FK_versionKey: newVersion.versionKey,
        },
      });
      const author = await authorApi.createAuthor({
        nameTagKey: 'Character 1',
        title: 'Character 1 Title',
        FK_versionKey: newVersion.versionKey,
      });

      await questionApi.addQuestion({
        payload: {
          FK_questionDisplayTypeKey: 1,
          FK_authorKey: author.authorKey,
          timer: 0,
          isImportant: 0,
          descriptionTagKey: 'Email 1',
          FK_questionGroupKey: questionGroup.questionGroupKey,
          isWrittenResponse: 0,
          isSmartThreading: 0,
          versionKey: newVersion.versionKey,
        },
      });

      await folderApi.createFolder({
        name: 'Company Files',
        FK_versionKey: newVersion.versionKey,
      });
      /* TODO END */
      commit('INSERT_VERSION', newVersion);
      return newVersion;
    },

    deleteVersion: async ({ commit }, { versionKey }) => {
      await versionApi.deleteVersion({ versionKey });
      commit('DELETE_VERSION', { versionKey });
    },

    duplicateVersion: async ({ commit }, { versionKey }) => {
      const newVersion = await versionApi.duplicateVersion({ versionKey });
      commit('SET_DUPLICATED_VERSION_KEY', newVersion.versionKey);
      commit('INSERT_VERSION', newVersion);
      commit(
        'editMode/version/UPDATE_VERSION',
        {
          updatedVersion: {
            ...newVersion,
          },
        },
        { root: true }
      );
    },
  },

  mutations: {
    SET_DUPLICATED_VERSION_KEY: (state, versionKey) => {
      Vue.set(state, 'duplicatedVersionKey', versionKey);
    },
    INSERT_ALL_VERSIONS: (state, versionList) => {
      state.versions = keyBy(versionList, 'versionKey');
    },
    IS_LOADING: (state, isLoading) => {
      Vue.set(state, 'isLoading', isLoading);
    },
    SET_FEATURED_PROJECTS: (state, featuredProj) => {
      Vue.set(state, 'featuredProjects', featuredProj);
    },
    SET_RECENT_PROJECTS: (state, versions) => {
      Vue.set(state, 'recentProjects', versions);
    },
    SET_AUTHOR_PROJECTS: (state, authorProjects) => {
      Vue.set(state, 'authorProjects', authorProjects);
    },
    INSERT_VERSION: (state, newVersion) => {
      Vue.set(state.versions, newVersion.versionKey, newVersion);
    },

    DELETE_VERSION: (state, { versionKey }) => {
      Vue.delete(state.versions, versionKey);
    },
    UPDATE_VERSION_NAME: (state, { versionKey, versionName }) => {
      if (versionKey in state.versions) {
        Vue.set(state.versions[versionKey], 'versionName', versionName);
      }
    },
  },

  getters: {
    versionList: (state) => Object.values(state.versions),
    recentProjects: (state) => state.recentProjects,
    featuredProjects: (state) => state.featuredProjects,
    isLoading: (state) => state.isLoading,
    duplicatedVersionKey: (state) => state.duplicatedVersionKey,
  },
};
